<template>
  <div class="utabs" :class="type">
    <div
      class="utabs-item"
      @click="clickItem(item)"
      :class="{ active: item.value == value }"
      v-for="(item, index) in list"
      :key="index"
    >
      {{ item.label }}
      <Icon
        class="del-btn"
        v-if="isDel || showDel(item, index)"
        @click="delItem(index)"
        type="md-close-circle"
      />
    </div>
    <Button v-if="isAdd" type="text" @click="addItem" size="small" icon="md-add"
      >添加</Button
    >
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String | Number,
      default: "",
    },
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isAdd: {
      type: Boolean,
      default: false,
    },
    isDel: {
      type: Boolean,
      default: false,
    },
    showDel: {
      type: Function,
      default: () => false,
    },
    type: {
      type: String,
      default: "utabs-type1",
    },
  },
  methods: {
    clickItem(item) {
      this.$emit("input", item.value);
      this.$emit("change", item.value);
    },
    delItem(index) {
      this.$emit("del", index);
    },
    addItem() {
      this.$emit("add");
    },
  },
};
</script>

<style lang="scss" scoped>
.utabs {
  display: flex;
  margin-bottom: 15px;
  .utabs-item {
    padding: 2px 0;
    margin-right: 20px;
    cursor: pointer;
    position: relative;
    &:hover {
      .del-btn {
        visibility: visible;
      }
    }
    .del-btn {
      visibility: hidden;
      position: absolute;
      right: -10px;
      top: -10px;
      font-size: 18px;
      padding: 5px;
      color: #f00;
      opacity: 0.7;
      &:hover {
        opacity: 1;
      }
    }
  }
  &.utabs-type1 {
    .utabs-item {
      font-size: 15px;
      &.active {
        border-bottom: 2px solid #f00;
        font-weight: bold;
      }
    }
  }
  &.utabs-type2 {
    .utabs-item {
      border-radius: 15px;
      border: 1px solid #ccc;
      padding: 0 15px;
      font-size: 14px;
      &.active {
        background: #333;
        color: #fff;
      }
    }
  }
  .ivu-btn {
    color: #f00;
  }
}
</style>